import React, { useState, useEffect } from "react";

declare const window: any;

const LoadingSpinner = ({ isLoading, logo }: any) => {
  const [rotateDeg, setRotateDeg] = useState(0);
  const [fillColor, setFillColor] = useState("300");

  useEffect(() => {
    const interval = setInterval(() => {
      // Incrementar el grado de rotación en 360 grados
      setRotateDeg((prevDeg) => prevDeg + 10); // Ajusta la velocidad de rotación aquí
    }, 20); // Cambiar cada 0.1 segundos (ajusta la velocidad del cambio de color aquí)

    return () => clearInterval(interval);
  }, []);

  /* useEffect(() => {
    const interval = setInterval(() => {
      // Cambiar el color de relleno entre blanco y negro
      setFillColor((prevColor) => (prevColor === "300" ? "0" : "300"));
    }, 1000); // Cambiar cada 0.1 segundos (ajusta la velocidad del cambio de color aquí)

    return () => clearInterval(interval);
  }, []); // Se ejecuta solo una vez al montar el componente */

  return (
    <div className={`spinner-container ${isLoading ? "show" : ""}`}>
      <img src={logo} alt="" style={{ filter: `invert(1) brightness(${fillColor}%)`, width: "4rem", height: "4rem" }} />
      <div
        className="circle"
        style={{
          borderRadius: "50%",
          width: "8rem",
          height: "8rem",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: `translate(-50%, -50%) rotate(${rotateDeg}deg)`,
          border: "2px solid white",
          borderTop: "2px solid transparent", // Para hacer el círculo sin relleno
        }}
      ></div>
    </div>
  );
};

export default LoadingSpinner;
